// @flow
import type { Epic } from '../../annotations';

import { combineEpics } from 'redux-most';

import filterEpic from './filters/filterEpic';
import filterSearchEpic from './filters/filterSearchEpic';
import resetFiltersEpic from './filters/resetEpic';
import filterTldEpic from './filters/filterTldEpic';
import backorderDomainEpic from './backorderDomainEpic';
import gaInitEpic from './gaInitEpic';
import localeEpic from './localeEpic';
import purchaseDomainEpic from './purchaseDomainEpic';
import purchaseBundleEpic from './purchaseBundleEpic';
// eslint-disable-next-line import/no-named-as-default
import searchEpic from './searchEpic';
import seedEpic from './seedEpic';
import sessionEpic from './sessionEpic';
import transferDomainEpic from './transferDomainEpic';
import viewBasketEpic from './viewBasketEpic';
import analyticsWorkerEpic from './analyticsWorkerEpic';
// eslint-disable-next-line import/no-named-as-default
import negotiateEpic from './negotiateEpic';
import emitEpic from './emitEpic';

export {
  sessionEpic,
  seedEpic,
  gaInitEpic,
  localeEpic,
  resetFiltersEpic,
  transferDomainEpic,
  backorderDomainEpic,
  filterEpic,
  filterSearchEpic,
  filterTldEpic,
  viewBasketEpic,
  searchEpic,
  purchaseDomainEpic,
  purchaseBundleEpic,
  analyticsWorkerEpic,
  negotiateEpic,
  emitEpic,
};

export const rootEpic = (...epics: Array<Epic>) => combineEpics(epics);
